import api, { getPaginatedList } from 'shared/api'

export const doLoad = async props => {
  return await getPaginatedList('/tags', props)
}

export const doCreateTag = async props => {
  return await api.post('/admin/tags', props)
}
